import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteName } from '../../models/enums';
import { NgModule } from '@angular/core';
import { Router, RouterOutlet, RouterModule, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-redirect-page',
  standalone: true,
  imports: [RouterModule, RouterOutlet], // Add RouterModule to the imports array
  templateUrl: './redirect-page.component.html',
  styleUrl: './redirect-page.component.scss'
})
export class RedirectPageComponent {

  marketRoute = RouteName.market;
  
    constructor(private router: Router) { }
  
    ngOnInit() {
    }

}
